import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon, TrendingUpIcon } from 'lucide-react';
export function PandoraBox() {
  // Generate some dummy candlestick data for the mockup
  const candles = Array.from({
    length: 30
  }).map((_, i) => {
    const isBullish = Math.random() > 0.4;
    const height = 20 + Math.random() * 40;
    const yOffset = 30 + Math.random() * 40;
    return {
      isBullish,
      height,
      yOffset
    };
  });
  return <section className="py-24 bg-dark relative overflow-hidden border-y border-surfaceHighlight" data-id="element-178">
      <div className="absolute inset-0 bg-circuit opacity-20" data-id="element-179"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-182">
            <span className="text-primary font-display font-bold tracking-widest uppercase text-sm mb-4 block flex items-center justify-center gap-2" data-id="element-183">
              <BoxIcon className="w-4 h-4" data-id="element-184" /> Algoritmo Exclusivo
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white mb-6 uppercase tracking-wide" data-id="element-185">
              El <span className="text-primary text-glow" data-id="element-186">Pandora Box</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto font-light" data-id="element-187">
              Identifica visualmente las zonas de acumulación institucionales
              antes de la apertura de New York. No operes el ruido, opera el
              break-out.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="glass-panel rounded-lg p-6 md:p-8 relative" data-id="element-188">
          {/* Chart Mockup */}
          <div className="w-full h-[400px] bg-dark/80 rounded border border-surfaceHighlight relative overflow-hidden flex items-end px-4 pb-12 pt-8" data-id="element-189">
            {/* Grid Lines */}
            <div className="absolute inset-0 flex flex-col justify-between pointer-events-none opacity-20" data-id="element-190">
              {[...Array(5)].map((_, i) => <div key={i} className="w-full h-px bg-primary/30" data-id="element-191"></div>)}
            </div>
            <div className="absolute inset-0 flex justify-between pointer-events-none opacity-20" data-id="element-192">
              {[...Array(10)].map((_, i) => <div key={i} className="h-full w-px bg-primary/30" data-id="element-193"></div>)}
            </div>

            {/* Price Labels (Y-axis) */}
            <div className="absolute right-2 top-0 bottom-12 flex flex-col justify-between text-[10px] text-gray-500 font-mono py-2" data-id="element-194">
              <span data-id="element-195">39,150</span>
              <span data-id="element-196">39,100</span>
              <span data-id="element-197">39,050</span>
              <span className="text-primary" data-id="element-198">39,000</span>
              <span data-id="element-199">38,950</span>
            </div>

            {/* Candlesticks */}
            <div className="relative w-full h-full flex items-end gap-1 sm:gap-2 justify-center z-10" data-id="element-200">
              {candles.map((candle, i) => <div key={i} className="relative flex flex-col items-center justify-end h-full w-2 sm:w-4" data-id="element-201">
                  {/* Wick */}
                  <div className={`absolute w-px ${candle.isBullish ? 'bg-bullish' : 'bg-danger'}`} style={{
                height: `${candle.height + 20}%`,
                bottom: `${candle.yOffset - 10}%`
              }} data-id="element-202"></div>
                  {/* Body */}
                  <div className={`absolute w-full rounded-sm ${candle.isBullish ? 'bg-bullish' : 'bg-danger'}`} style={{
                height: `${candle.height}%`,
                bottom: `${candle.yOffset}%`
              }} data-id="element-203"></div>
                </div>)}

              {/* The Pandora Box (Accumulation Zone) */}
              <div className="absolute left-[20%] right-[40%] top-[40%] bottom-[30%] border-2 border-primary bg-primary/10 box-glow z-20 flex items-center justify-center" data-id="element-204">
                <span className="text-primary font-display text-xs sm:text-sm font-bold bg-dark/80 px-2 py-1 rounded border border-primary/50" data-id="element-205">
                  ZONA DE ACUMULACIÓN
                </span>
              </div>

              {/* Breakout Arrow */}
              <div className="absolute right-[25%] top-[20%] z-30 flex flex-col items-center animate-bounce" data-id="element-206">
                <span className="text-bullish font-display text-xs font-bold mb-1 bg-dark/80 px-2 py-1 rounded border border-bullish/50" data-id="element-207">
                  BREAK-OUT
                </span>
                <TrendingUpIcon className="w-8 h-8 text-bullish" data-id="element-208" />
              </div>
            </div>

            {/* Time Labels (X-axis) */}
            <div className="absolute bottom-2 left-4 right-12 flex justify-between text-[10px] text-gray-500 font-mono border-t border-surfaceHighlight pt-2" data-id="element-209">
              <span data-id="element-210">08:00 EST</span>
              <span data-id="element-211">08:30 EST</span>
              <span className="text-primary font-bold" data-id="element-212">
                09:30 EST (NY OPEN)
              </span>
              <span data-id="element-213">10:00 EST</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}